import type { AdminDashboardData } from '@workspace/api-backend'
import { MetricCard } from '@workspace/ui/components/metric-card'
import { DashboardSection } from './dashboard-card'

export function ActivitySection({ data }: { data: AdminDashboardData }) {
  const { activity } = data.engagement
  return (
    <DashboardSection title="Activity">
      <div className="grid gap-4 sm:grid-cols-3">
        <MetricCard
          label="Online today"
          value={activity.onlineToday.toLocaleString()}
          variant="highlight"
        />
        <MetricCard label="Online this week" value={activity.online7d.toLocaleString()} />
        <MetricCard label="Online this month" value={activity.online30d.toLocaleString()} />
      </div>
    </DashboardSection>
  )
}
